import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const fixedColors = [
  "#F8ED8C", "#F2B28C", "#ADB2D4","#FFB8E0", "#818C78",  "#89216b",
  "#A569BD", "#45B39D", "#F39C12", "#D35400"
];

const getColors = (count) =>
  Array.from({ length: count }, (_, i) => fixedColors[i % fixedColors.length]);

const DoughnutChart = ({ labels = [], values = [] }) => {
  const [reviewedPercentage, setReviewedPercentage] = useState(0);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [hoveredColor, setHoveredColor] = useState(fixedColors[0]); // Default color

  const backgroundColors = getColors(values.length);

  const handleChartHover = (event, elements) => {
    if (elements.length > 0) {
      const index = elements[0].index;
      const total = values.reduce((acc, val) => acc + val, 0);
      const percentage = total
        ? ((values[index] / total) * 100).toFixed(2).replace(/\.00$/, "")
        : 0;

      setReviewedPercentage(percentage);
      setSelectedLabel(labels[index]);
      setHoveredColor(backgroundColors[index]); // Set hovered color
    }
  };

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors.map((color) => color + "CC"),
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "50%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: { size: 14 },
        },
      },
      tooltip: { enabled: true },
      datalabels: {
        color: "black",
        font: { size: 14 },
        formatter: (value) => (value > 0 ? value : null),
      },
    },
    onHover: handleChartHover,
  };

  useEffect(() => {
    if (values.length > 0) {
      const total = values.reduce((acc, val) => acc + val, 0);
      const percentage = total
        ? ((values[0] / total) * 100).toFixed(2).replace(/\.00$/, "")
        : 0;

      setReviewedPercentage(percentage);
      setSelectedLabel(labels[0]); // Set to first label by default
      setHoveredColor(backgroundColors[0]); // Set default color
    }
  }, [labels, values]); // Runs when data changes

  return (
    <div style={{ width: "400px", textAlign: "center" }}>
      <p className="chart-header">
        <span
          className="highlight-box"
          style={{ backgroundColor: hoveredColor, padding: "5px", borderRadius: "5px", color: "#000",fontWeight:"600" }}
        >
          {reviewedPercentage}%
        </span>{" "}
        {selectedLabel}
      </p>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DoughnutChart;
